import React, { createContext, useContext, useState, FC, ReactNode } from 'react';

interface EventContextType {
    onFormChange: (listener: EventListener) => void;
    unsubscribe: (listener: EventListener) => void;
    notify: (changedValues: any, values: any) => void;
}

type EventListener = (changedValues: any, values: any) => void;

const EventContext = createContext<EventContextType | undefined>(undefined);

export const EventProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [listeners, setListeners] = useState<EventListener[]>([]);

    const onFormChange = (listener: EventListener) => {
        setListeners((prevListeners) => [...prevListeners, listener]);
    };

    const unsubscribe = (listener: EventListener) => {
        setListeners((prevListeners) => prevListeners.filter((l) => l !== listener));
    };

    const notify = (changedValues: any, values: any) => {
        listeners.forEach((listener) => {
            listener(changedValues, values);
        });
    };

    return (
            <EventContext.Provider value={{ onFormChange, unsubscribe, notify }}>
                {children}
            </EventContext.Provider>
    );
};

export const useFormEventListener = (): EventContextType => {
    const context = useContext(EventContext);
    if (!context) {
        throw new Error('useFormEventListener must be used within an EventProvider');
    }
    return context;
};
